import { render } from "./VehicleCart.vue?vue&type=template&id=25211ff2&scoped=true&bindings={}"
import script from "./VehicleCart.vue?vue&type=script&lang=ts"
export * from "./VehicleCart.vue?vue&type=script&lang=ts"

import "./VehicleCart.vue?vue&type=style&index=0&id=25211ff2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25211ff2"

export default script